import { Action, ACTION_TYPE, MODULE_TYPE } from '@abiglobalhealth/go-types'

import { actionsRequest } from './utils'

export const getAssessmentModule = async <T extends Action<ACTION_TYPE.GET_ASSESSMENT_SURVEY_MODULE>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.GET_ASSESSMENT_SURVEY_MODULE
  })

  if (!body?.data) throw new Error('No data')

  return { ...body.data, type: MODULE_TYPE.INDICATION_SURVEY }
}

export const setAssessmentSurveyAnswers = async <T extends Action<ACTION_TYPE.SET_ASSESSMENT_SURVEY_ANSWERS>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.SET_ASSESSMENT_SURVEY_ANSWERS
  })

  if (!body?.data) throw new Error('No data')

  return body.data
}
